import { StyleSheet, Text, View } from 'react-native'
import React from 'react'
import GlobalStyles from '../../../../globalStyles/globalStyles'
import { Colors } from '../../../../globalStyles/ColorConfig'

const ConfirmedGoldenBottom = () => {
  return (
    <View style={[{position: 'absolute',
    height: 30,
    width: '100%',
    backgroundColor: Colors.gold10,
    opacity: 0.8,
    bottom: 0,
    zIndex: 1,
    justifyContent: 'center',
    alignItems: 'center'},]}>
      <Text style={[GlobalStyles.captionText, {color: Colors.white10}]}>Confirmed</Text>
    </View>
  )
}

export default ConfirmedGoldenBottom

const styles = StyleSheet.create({})